import { apiUrl } from "./api";

/**
 * Die Id des Kontakttyps „Person".
 *
 * Ohne sie entsteht ein Kontakt ohne Typ: `buildPrivateContactCreatePayload`
 * setzt `type` nur, wenn die Id mitkommt — anders als der Firmen-Payload, der
 * seinen Typ fest mitschickt.
 *
 * Zwei ältere, wortgleiche Kopien stehen als lokale Helfer in
 * `RelationshipDetails.tsx` und `NewPrivateContactPage.tsx`. Sie hier
 * mitzuziehen wäre eine eigene Änderung an zwei viel benutzten Masken; neue
 * Aufrufer nehmen diese Fassung.
 */
export async function resolvePersonTypeId(): Promise<number | undefined> {
  try {
    const res = await fetch(apiUrl("contacttype"));
    const list = await res.json();
    const treffer = Array.isArray(list)
      ? list.find((t: { type?: unknown }) => String(t?.type).toLowerCase() === "person")
      : null;
    return (treffer as { id?: number } | null)?.id;
  } catch {
    return undefined;
  }
}
